export default __webpack_public_path__ + "static/media/people.c1c76acc.svg";